import { type IntegrationServiceId } from '../../common/integrations'
import { FileBrowser, type FileBrowserProps } from './FileBrowser'
import { useDocumentFileBrowser } from './useDocumentFileBrowser'

type InheritedFileBrowserProps = Omit<
  FileBrowserProps,
  'serviceId' | 'onFolderOpen' | 'onLoadMore' | 'onSearch' | 'onSearchLoadMore' | 'workspaces' | 'workspace' | 'onWorkspaceChange'
>

export interface IntegrationFileBrowserProps extends InheritedFileBrowserProps {
  serviceId: IntegrationServiceId
  initialFolderIds?: string[]
  initialFoldersReady?: boolean
}

export const IntegrationFileBrowser = ({ serviceId, initialFolderIds, initialFoldersReady, ...browserProps }: IntegrationFileBrowserProps) => {
  const { loadFolder, loadMoreItems, searchItems, loadMoreSearchItems, workspaces, workspace, onWorkspaceChange } = useDocumentFileBrowser(serviceId, {
    initialFolderIds,
    initialFoldersReady,
  })

  return (
    <FileBrowser
      serviceId={serviceId}
      onFolderOpen={loadFolder}
      onLoadMore={loadMoreItems}
      onSearch={searchItems}
      onSearchLoadMore={loadMoreSearchItems}
      workspaces={workspaces}
      workspace={workspace}
      onWorkspaceChange={onWorkspaceChange}
      {...browserProps}
    />
  )
}
